module.exports = __webpack_public_path__ + "img/daijinquan_bg.7cb9cac9.png";